var map = {
	"./en.article1.json": 44,
	"./en.article2.json": 8157,
	"./en.article3.json": 857,
	"./en.article4.json": 2458,
	"./en.article5.json": 4129,
	"./en.article6.json": 9957,
	"./en.article7.json": 9110,
	"./en.json": 1008,
	"./ua.article1.json": 2676,
	"./ua.article2.json": 3442,
	"./ua.article3.json": 8502,
	"./ua.article4.json": 6540,
	"./ua.article5.json": 6969,
	"./ua.article6.json": 1357,
	"./ua.article7.json": 1562,
	"./ua.json": 8391
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1946;
module.exports = webpackAsyncContext;